/**
 * Parsuje JSONa, w przypadku niepowodzenia zwraca domyślną wartość
 *
 * @export
 * @template T
 * @param {string} json
 * @param {T} [defaultValue]
 * @returns {(T | undefined)}
 */
export function parseJsonOrDefault<T>(json: string | null, defaultValue?: T): T {
  if (!json) {
    return defaultValue as T;
  }

  try {
    return JSON.parse(json);
  } catch (err) {
    return defaultValue as T;
  }
}
